import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Link to="/">
          <Button variant="ghost" size="sm" className="mb-6 gap-1.5">
            <ArrowLeft className="h-4 w-4" />
            トップへ戻る
          </Button>
        </Link>

        <h1 className="text-lg font-bold mb-1">利用規約</h1>
        <p className="text-xs text-muted-foreground mb-6">最終更新日: 2026年2月18日</p>

        <div className="max-w-none space-y-4 text-xs">
          <section>
            <h2 className="text-sm font-semibold mb-1">第1条（総則）</h2>
            <p className="text-muted-foreground leading-relaxed">
              本利用規約（以下「本規約」といいます）は、Hitorigoto（以下「本サービス」といいます）の利用に関する条件を、本サービスを利用するすべてのユーザー（以下「ユーザー」といいます）と本サービスの運営者（以下「運営者」といいます）との間で定めるものです。
              ユーザーは、本サービスを利用することにより、本規約のすべての条項に同意したものとみなされます。
              本規約に同意いただけない場合は、本サービスのご利用をお控えください。
              なお、本規約のほか、運営者が本サービスに関して別途定める個別規定、ガイドライン、ヘルプページ等（以下「個別規定等」といいます）も、名称のいかんにかかわらず、本規約の一部を構成するものとします。
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1">第2条（定義）</h2>
            <p className="text-muted-foreground leading-relaxed mb-1">本規約において、以下の用語は次の意味を有するものとします。</p>
            <ul className="list-disc pl-5 text-muted-foreground space-y-1">
              <li>「本サービス」とは、運営者が提供する音声入力による日記作成支援ウェブアプリケーション Hitorigoto およびこれに付随する一切のサービスをいいます。</li>
              <li>「ユーザー」とは、本規約に同意の上、本サービスを利用するすべての個人をいい、ゲストアカウントを通じて利用する者を含みます。</li>
              <li>「コンテンツ」とは、ユーザーが本サービスを通じて作成、記録、送信、保存した音声データ、テキストデータ、画像データおよびそれらから生成された要約・分析結果等の一切の情報をいいます。</li>
              <li>「有料プラン」とは、本サービスが提供する月額または年額の定額制サブスクリプションプランをいい、無料プランでは利用できない追加機能が含まれます。</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1">第3条（サービスの概要）</h2>
            <p className="text-muted-foreground leading-relaxed">
              本サービスは、音声入力による日記の作成を支援するウェブアプリケーションであり、音声の文字起こし、AI による日記テキストの要約、感情分析、カテゴリ分類、定期的な振り返りコンテンツの自動生成等の機能を提供します。
              本サービスの具体的な機能内容、提供範囲、利用可能なプラットフォームおよび対応環境は、運営者が別途定めるものとし、予告なく変更される場合があります。
              本サービスは医療、心理カウンセリング、その他の専門的サービスを提供するものではありません。AI による分析結果はあくまで参考情報であり、専門家のアドバイスに代わるものではありません。
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1">第4条（アカウント）</h2>
            <p className="text-muted-foreground leading-relaxed mb-1">
              本サービスの利用にはアカウントの作成が必要です。ユーザーは、アカウント登録にあたり、真実かつ正確な情報を提供するものとし、登録情報に変更が生じた場合は、速やかに更新するものとします。
            </p>
            <ul className="list-disc pl-5 text-muted-foreground space-y-1">
              <li>ユーザーは、自己のアカウントに関するログイン情報（メールアドレス、パスワード等）を適切に管理する責任を負い、これを第三者に利用させ、貸与し、譲渡し、名義変更し、または担保に供してはならないものとします。</li>
              <li>アカウントのログイン情報の管理不十分、使用上の過誤または第三者による不正使用等に起因する損害については、運営者は一切の責任を負いません。</li>
              <li>ゲストアカウントは、本サービスの試用を目的として提供されるものであり、ゲストアカウントに関連するデータは、一定期間（原則として90日間）の非活動状態が続いた場合に、事前通知なく削除されることがあります。ゲストアカウントのデータの消失について、運営者は一切の責任を負いません。</li>
              <li>ユーザーが本規約に違反した場合、運営者は当該ユーザーのアカウントを事前通知なく停止または削除することができるものとします。</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1">第5条（禁止事項）</h2>
            <p className="text-muted-foreground leading-relaxed mb-1">ユーザーは、本サービスの利用にあたり、以下の各号に定める行為を行ってはならないものとします。</p>
            <ul className="list-disc pl-5 text-muted-foreground space-y-1">
              <li>法令または公序良俗に違反する行為、犯罪行為に関連する行為、またはそのおそれのある行為</li>
              <li>運営者、他のユーザーまたは第三者の知的財産権、肖像権、プライバシー権、名誉権その他一切の権利または利益を侵害する行為</li>
              <li>本サービスのサーバーまたはネットワークに過度の負荷をかける行為、またはサービスの運営を妨害するおそれのある行為</li>
              <li>本サービスに対する不正アクセス、コンピュータウイルス等の有害なプログラムの送信、またはセキュリティ機能を回避する行為</li>
              <li>本サービスのソフトウェアを逆コンパイル、逆アセンブル、リバースエンジニアリング、またはその他の方法でソースコードを解析する行為</li>
              <li>自動化されたスクリプト、ボット、クローラー、スクレイパーその他の自動手段を使用して本サービスにアクセスし、またはデータを収集する行為</li>
              <li>他のユーザーのアカウントを不正に使用する行為、または他者になりすます行為</li>
              <li>本サービスを、本来の目的（個人の日記作成）以外の目的（商業目的、広告配信、スパム送信等）で利用する行為</li>
              <li>反社会的勢力等に対する利益供与その他の協力行為</li>
              <li>前各号に準ずる行為、その他運営者が不適切と合理的に判断する行為</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1">第6条（知的財産権）</h2>
            <p className="text-muted-foreground leading-relaxed">
              本サービスを構成するソフトウェア、アルゴリズム、デザイン、ロゴ、商標、ドキュメント、ユーザーインターフェースその他一切の著作物に関する知的財産権（著作権法第27条および第28条に定める権利を含みます）は、運営者または正当な権利者に帰属します。
              本規約に基づく本サービスの利用許諾は、本サービスに関する運営者の知的財産権の譲渡または移転を意味するものではありません。
              ユーザーが本サービスを通じて作成したコンテンツ（日記テキスト、音声データ等）に関する著作権その他の知的財産権は、ユーザー自身に帰属します。
              ただし、ユーザーは、運営者に対し、本サービスの提供、維持、改善に必要な範囲（音声の文字起こし処理、AI による分析・要約処理、バックアップの作成、サービスの品質向上のための統計的分析等を含みますがこれに限りません）において、ユーザーのコンテンツを利用する非独占的かつ無償のライセンスを付与するものとします。
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1">第7条（有料プラン）</h2>
            <ul className="list-disc pl-5 text-muted-foreground space-y-1">
              <li>本サービスの有料プランの決済は、外部の決済代行サービスを通じて処理されます。決済に関する条件は、当該決済代行サービスの利用規約にも従うものとします。</li>
              <li>有料プランの料金、提供される機能の内容、およびプランの種類は、運営者の判断により変更される場合があります。料金の改定がある場合は、改定の適用日の少なくとも30日前までに、本サービス内での通知またはメールにより、ユーザーに対して事前に告知します。</li>
              <li>サブスクリプションは、現在の課金期間が終了する少なくとも24時間前までに解約手続きを行わない限り、自動的に更新されます。</li>
              <li>サブスクリプションの解約はいつでも可能です。解約手続き後は、当該課金期間の終了日まで有料プランの機能をご利用いただけます。課金期間の途中での解約による日割り返金は行いません。</li>
              <li>法令で認められる場合を除き、支払い済みの利用料金の返金は原則として行いません。ただし、本サービスの重大な不具合により有料プランの機能がまったく利用できない状態が相当期間継続した場合は、個別に対応を検討します。</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1">第8条（免責事項および保証の否認）</h2>
            <ul className="list-disc pl-5 text-muted-foreground space-y-1">
              <li>本サービスは「現状のまま（as is）」かつ「提供可能な限度（as available）」で提供されます。運営者は、本サービスの完全性、正確性、確実性、有用性、特定目的への適合性、セキュリティ上の欠陥・エラー・バグがないこと、権利侵害がないこと等について、明示的にも黙示的にも一切保証しません。</li>
              <li>AI による分析結果（感情分析、要約、振り返りコンテンツ等）は、機械学習モデルにより自動生成された参考情報であり、その正確性、適切性、完全性について運営者は一切保証しません。AI が生成した情報に基づいてユーザーが行った判断や行動について、運営者は一切の責任を負いません。</li>
              <li>本サービスの利用に起因してユーザーに生じた損害（逸失利益、データの消失、事業の中断、精神的損害等を含みますがこれに限りません）について、運営者の故意または重過失による場合を除き、運営者は法令で認められる最大限の範囲で責任を負いません。</li>
              <li>運営者が損害賠償責任を負う場合であっても、運営者の賠償責任は、当該ユーザーが過去12ヶ月間に本サービスに対して支払った利用料金の総額を上限とします。</li>
              <li>サーバーの障害、メンテナンス、通信回線の障害、天災地変、停電その他の不可抗力により本サービスの提供が一時的に中断または停止する場合があります。運営者は、かかる中断または停止によりユーザーに生じた損害について責任を負いません。</li>
              <li>本サービスから外部のウェブサイトまたはサービスへのリンクが含まれる場合がありますが、運営者は当該外部サイトの内容、プライバシーポリシー、安全性等について一切の責任を負いません。</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1">第9条（サービスの変更・中断・終了）</h2>
            <p className="text-muted-foreground leading-relaxed">
              運営者は、以下の各号に定める場合、ユーザーに事前に通知することなく、本サービスの全部または一部の提供を一時的に中断することができるものとします。
            </p>
            <ul className="list-disc pl-5 text-muted-foreground space-y-1 mt-1">
              <li>本サービスのシステムの保守点検または更新を行う場合</li>
              <li>地震、落雷、火災、停電、天災その他の不可抗力により本サービスの提供が困難となった場合</li>
              <li>通信回線等の障害により本サービスの提供が困難となった場合</li>
              <li>セキュリティ上の問題が発生し、緊急の対応が必要な場合</li>
              <li>その他、運営者が本サービスの提供の一時中断が必要と合理的に判断した場合</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-1">
              運営者は、少なくとも30日前の事前通知をもって、本サービスの全部または一部を終了することができるものとします。
              サービス終了の際は、ユーザーが自身のコンテンツデータをエクスポートまたはダウンロードできる十分な猶予期間を設けるよう合理的な努力を行います。
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1">第10条（ユーザーの責任）</h2>
            <p className="text-muted-foreground leading-relaxed">
              ユーザーは、自己の責任において本サービスを利用するものとし、本サービスの利用に関連して行ったすべての行為およびその結果について、一切の責任を負うものとします。
              ユーザーが本規約に違反し、または本サービスの利用に関連して運営者に損害を与えた場合、ユーザーは当該損害（弁護士費用を含みます）を運営者に賠償するものとします。
              ユーザーと第三者との間で紛争が生じた場合、ユーザーは自己の費用と責任においてこれを解決するものとし、運営者は一切の責任を負いません。
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1">第11条（個人情報の取扱い）</h2>
            <p className="text-muted-foreground leading-relaxed">
              運営者は、本サービスの利用に伴い取得するユーザーの個人情報を、運営者が別途定めるプライバシーポリシーに従い、適切に取り扱うものとします。
              ユーザーは、本サービスを利用するにあたり、当該プライバシーポリシーの内容を確認し、これに同意するものとします。
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1">第12条（通知）</h2>
            <p className="text-muted-foreground leading-relaxed">
              運営者からユーザーへの通知は、本サービス内での掲示、ユーザーが登録したメールアドレスへの電子メールの送信、またはその他運営者が適当と判断する方法により行うものとします。
              本サービス内での掲示による通知は、当該掲示が本サービス上に表示された時点から効力を生じるものとします。
              電子メールによる通知は、運営者がメールを送信した時点から効力を生じるものとします。
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1">第13条（権利義務の譲渡禁止）</h2>
            <p className="text-muted-foreground leading-relaxed">
              ユーザーは、運営者の書面による事前の承諾なく、本規約上の地位、または本規約に基づく権利もしくは義務の全部または一部を第三者に譲渡し、承継させ、または担保に供してはならないものとします。
              運営者は、本サービスに関する事業の全部または一部を第三者に譲渡（事業譲渡、会社分割その他形態のいかんを問いません）する場合、当該譲渡に伴い、本規約上の地位、権利義務ならびにユーザーの登録情報その他の情報を当該譲渡先の第三者に移転できるものとし、ユーザーはかかる移転について予め同意するものとします。
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1">第14条（分離可能性）</h2>
            <p className="text-muted-foreground leading-relaxed">
              本規約のいずれかの条項またはその一部が、法令等により無効または執行不能と判断された場合であっても、当該条項の残りの部分および本規約のその他の条項は、引き続き完全に効力を有するものとします。
              無効または執行不能と判断された条項については、当該条項が意図する目的を可能な限り達成できるよう、合理的に解釈されるものとします。
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1">第15条（規約の変更）</h2>
            <p className="text-muted-foreground leading-relaxed">
              運営者は、必要と判断した場合には、ユーザーの個別の同意を要することなく、本規約を変更することができるものとします。
              変更後の本規約は、本サービス上に掲載された時点から効力を生じるものとし、重要な変更がある場合は、変更の適用日の少なくとも14日前までに、本サービス内での通知、メールの送信、またはウェブサイト上への掲載等の適切な方法により、変更内容をユーザーに通知します。
              変更後の本規約の施行日以降に本サービスを継続して利用する場合、ユーザーは変更後の本規約に同意したものとみなされます。変更に同意いただけない場合は、本サービスの利用を中止してください。
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1">第16条（準拠法および管轄裁判所）</h2>
            <p className="text-muted-foreground leading-relaxed">
              本規約の解釈および適用は、日本法に準拠するものとします。
              本規約に関連して生じた一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1">第17条（お問い合わせ）</h2>
            <p className="text-muted-foreground leading-relaxed">
              本規約に関するご質問、ご意見その他のお問い合わせは、アプリ内のサポート機能よりご連絡ください。
              運営者は、受領したお問い合わせに対し、合理的な期間内に回答するよう努めます。
            </p>
          </section>
        </div>

        <div className="mt-8 pt-6 border-t text-center text-sm text-muted-foreground">
          <Link to="/privacy" className="hover:underline">プライバシーポリシー</Link>
          <span className="mx-2">|</span>
          <Link to="/" className="hover:underline">トップページ</Link>
        </div>
      </div>
    </div>
  );
}
